import { AfterViewInit, Component, HostListener, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { ConferenceRegistrantViewModel, ConferenceViewModelWithDetails, RegistrantSearchParameters } from 'src/app/_models/generatedModels';
import { OrganizationService } from 'src/app/_services/generatedServices';
import { ToasterService } from 'src/app/_services/toaster.service';
import Keyboard from "simple-keyboard";
import { ActivatedRoute, Router } from "@angular/router";
import { CheckinService } from "../../_services/checkin.service";
import { IdleService } from "../../_services/idle.service";

declare var zE: any;

@Component({
  selector: 'bxl-checkin-preview-modal',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'checkin-preview-modal.component.html',
})
export class CheckinPreviewModalComponent implements OnInit, AfterViewInit {
  initialized = false;
  @Input() user: ConferenceRegistrantViewModel;
  @ViewChild('myForm') myForm: FormGroupDirective;
  private rfidValue = '';
  finalRFIDValue = '';
  // finalRFIDValue = '1890142775';

  inputName = "firstName";
  inputs = {
    firstName: ""
  };

  keyboard2: Keyboard;
  private currentInput: any;
  keyboardVisible: boolean;

  //@Input() conference: ConferenceViewModelWithDetails;
  submitComplete: Promise<any>;
  conferenceId: number;
  organizationId: string;
  userId: string;
  formDirty: boolean;

  constructor(private orgService: OrganizationService, private idleService: IdleService, private router: Router, public checkinService: CheckinService, private route: ActivatedRoute, private activeModal: NgbActiveModal, private toaster: ToasterService) {
    idleService.idle$.subscribe(s => this.cancel());
    idleService.wake$.subscribe(s => console.log('im awake!'));
  }

  ngOnInit(): void {
    zE('webWidget', 'hide');

    this.user = this.checkinService.user;
    this.conferenceId = this.checkinService.conference.id;
    this.organizationId = this.checkinService.organization.id.toString();
    this.initialized = true;
  }

  ngAfterViewInit() {
    console.log('ngAfterViewInit');

    if (this.checkinService.rfidEnabled) {
      this.keyboard2 = new Keyboard(".simple-keyboard2", {
        debug: true,
        theme: "hg-theme-default hg-theme-ios",
        inputName: this.inputName,
        onChange: (input) => this.onChange(input),
        onKeyPress: (button) => this.onKeyPress(button),
        disableCaretPositioning: false,
        preventMouseDownDefault: true, // If you want to keep focus on input,
        layout: {
          default: [
            "q w e r t y u i o p {bksp}",
            "a s d f g h j k l {enter}",
            "{shift} z x c v b n m , . {shift}",
            "{alt} {space} {downkeyboard}"
          ],
          shift: [
            "Q W E R T Y U I O P {bksp}",
            "A S D F G H J K L {enter}",
            "{shiftactivated} Z X C V B N M , . {shiftactivated}",
            "{alt} {space} {downkeyboard}"
          ],
          alt: [
            "1 2 3 4 5 6 7 8 9 0 {bksp}",
            `@ # $ & * ( ) ' " {enter}`,
            "{shift} % - _ + = / ; : ! ? {shift}",
            "{default} {space} {downkeyboard}"
          ]
        },
        display: {
          "{alt}": ".?123",
          "{shift}": "⇧",
          "{shiftactivated}": "⇧",
          "{enter}": "return",
          "{bksp}": "⌫",
          "{altright}": ".?123",
          "{downkeyboard}": "🞃",
          "{space}": "            ",
          "{default}": "ABC",
          "{back}": "⇦"
        }
      });
    }

    /**
     * Since we have default values for our inputs,
     * we must sync them with simple-keyboard
     */
    //this.keyboard.replaceInput(this.inputs);
  }

  onInputFocus = (event: any) => {
    if (!this.checkinService.rfidEnabled) {
      return;
    }
    this.keyboardVisible = true;
    this.inputName = event.target.id;
    this.currentInput = event.target;
    this.keyboard2.setInput(event.target.value, this.currentInput.id);


    var selectionStart = event.target.selectionStart;
    console.log(selectionStart);

    console.log("Focused input", this.inputName);

    this.keyboard2.setOptions({
      inputName: event.target.id
    });

  };

  reset() {
    if (!this.checkinService.rfidEnabled) {
      return;
    }
    this.keyboardVisible = false;
    this.keyboard2.setInput('', this.currentInput.id);
    this.currentInput.value = '';
    this.currentInput.dispatchEvent(new Event("change"));
    this.currentInput.dispatchEvent(new Event("input"));
  }

  setInputCaretPosition = (elem: any, pos: number) => {
    if (!this.checkinService.rfidEnabled) {
      return;
    }
    console.log("setInputCaretPosition", elem, pos);
    if (elem.setSelectionRange) {
      elem.focus();
      elem.setSelectionRange(pos, pos);
    }
  };

  onInputChange = (event: any) => {
    if (!this.checkinService.rfidEnabled) {
      return;
    }
    console.log("onInputChange", event.target.value);
    this.keyboard2.setInput(event.target.value);
  };

  public mouseUp($event: any) {

    // var selectionStart = $event.target.selectionStart;
    // console.log(selectionStart);
    // this.keyboard.setCaretPosition(3);
    // this.setInputCaretPosition($event.target, 3);
  }


  onChange = (input: string) => {
    if (!this.checkinService.rfidEnabled) {
      return;
    }
    this.currentInput.value = input;
    //this.model.searchText = input;
    console.log("Input changed", input);

    /**
     * Synchronizing input caret position
     * This part is optional and only relevant if using the option "preventMouseDownDefault: true"
     */
    let caretPosition = this.keyboard2.caretPosition;

    if (caretPosition !== null)
      this.setInputCaretPosition(
        document.querySelector(`#${this.inputName}`),
        caretPosition
      );

    console.log("caretPosition", caretPosition);
    this.currentInput.dispatchEvent(new Event("change"));
    this.currentInput.dispatchEvent(new Event("input")); // Use for Chrome/Firefox/Edge
  };

  onKeyPress = (button: string) => {
    if (!this.checkinService.rfidEnabled) {
      return;
    }
    console.log("Button pressed", button);

    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button.includes("{") && button.includes("}")) {
      this.handleLayoutChange(button);
    }
  };

  handleLayoutChange(button) {
    if (!this.checkinService.rfidEnabled) {
      return;
    }
    let currentLayout = this.keyboard2.options.layoutName;
    let layoutName;

    console.log(currentLayout);

    switch (button) {
      case "{shift}":
      case "{shiftactivated}":
      case "{default}":
        layoutName = currentLayout === "default" ? "shift" : "default";
        break;

      case "{alt}":
      case "{altright}":
        layoutName = currentLayout === "alt" ? "default" : "alt";
        break;

      case "{smileys}":
        layoutName = currentLayout === "smileys" ? "default" : "smileys";
        break;

      default:
        break;
    }

    if (layoutName) {
      this.keyboard2.setOptions({
        layoutName: layoutName
      });
    }
  }

  handleShift = () => {
    let currentLayout = this.keyboard2.options.layoutName;
    let shiftToggle = currentLayout === "default" ? "shift" : "default";

    this.keyboard2.setOptions({
      layoutName: shiftToggle
    });
  };


  @HostListener('window:keyup', ['$event'])
  onKeyUp(event: KeyboardEvent) {
    if (!this.checkinService.rfidEnabled) {
      return;
    }
    this.rfidValue += event.key;
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (event.key === 'Enter') {
      this.finalRFIDValue = this.rfidValue.replace('Enter', '');
      if (this.finalRFIDValue.length != 10) {
        this.finalRFIDValue = '';
      }
      this.rfidValue = '';
    }

    console.log('RFID Value: ', this.rfidValue);
    console.log('Final RFID Value: ', this.finalRFIDValue);
    return false;
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (!this.checkinService.rfidEnabled) {
      return;
    }

    event.stopPropagation();
    event.stopImmediatePropagation();

    console.log('RFID Value: ', this.rfidValue);
    return false;
  }

  completeCheckin(validateRFID: boolean) {
    if (!this.myForm.valid || (this.finalRFIDValue.length != 10 && validateRFID)) {
      this.myForm.form.markAllControlsDirty();
      this.formDirty = validateRFID;
      this.toaster.error('Please fill out all required fields!', 'Error');
      return;
    }

    this.user.rfidCode = +this.finalRFIDValue;
    var completeMessage = 'Checkin Complete! Your badge is currently printing. <br><br>Please make sure to download the <strong>BehaviorLive<strong> mobile app to earn CEUs and participate!';
    if (this.checkinService.mode == 'rekey') {
      completeMessage = 'RFID Assignment complete! Please make sure to download the <strong>BehaviorLive<strong> mobile app to earn CEUs and participate!';
    }

    if (!validateRFID){
      this.user.rfidCode = null;
    }

    this.submitComplete = new Promise((resetButton: any, reject) => {
      this.orgService.checkinToConference(this.conferenceId, this.checkinService.mode == 'rekey', this.user).subscribe(
        (data) => {
          this.toaster.toastDialog(completeMessage, 'Complete').subscribe((dialog) => {
            of(null)
              .pipe(delay(5000))
              .subscribe((result) => {
                dialog.close();
              });
          });
          this.cancel();
          resetButton();
        },
        (error) => {
          this.toaster.toastDialog(error.error[0], 'Error', 'OK', true).subscribe();
          resetButton();
        }
      );
    });
  }

  cancel() {
    this.checkinService.reset();
    this.router.navigate(['../'], {relativeTo: this.route});
  }
}
